import React, { useEffect, useState } from "react";
import { FlagSvg } from "assets/images/common/svgs";
import useUsers from "containers/user-management/useHooks";
import { useSelector } from "react-redux";
import DataNotFound from "components/particles/table/data-not-found";


interface Props {
  user: any;
}
const Wallet: React.FC<Props> = ({ user }) => {
  const [activeTab, setActiveTab] = useState("Earned Points");

  const { getActivitiesEarnedPoints, getProductRequests } = useUsers();
  const { isLoading } = useSelector((state: any) => state.sharedReducer);
  const [earnPoints, setEarnPoints] = useState<any[]>([]);
  const [productRequests, setProductRequests] = useState<any[]>([]);

  // Separate pagination states for each tab
  const [earnPointsPage, setEarnPointsPage] = useState(0);
  const [earnPointsHasMore, setEarnPointsHasMore] = useState(false);
  
  const [productRequestsPage, setProductRequestsPage] = useState(0);
  const [productRequestsHasMore, setProductRequestsHasMore] = useState(false);

  const loadEarnPoints = async (pageToLoad: number = 0) => {
    if (!user?.user?.id) return;

    await getActivitiesEarnedPoints(
      setEarnPoints,
      {
        page: pageToLoad,
        size: 5,
        ambassadorId: user?.user?.id,
      },
      pageToLoad,
      setEarnPointsHasMore
    );
    setEarnPointsPage(pageToLoad + 1);
  };

  const loadProductRequests = async (pageToLoad: number = 0) => {
    if (!user?.user?.id) return;

    await getProductRequests(
      setProductRequests,
      {
        page: pageToLoad,
        size: 5,
        ambassadorId: user?.user?.id,
      },
      pageToLoad,
      setProductRequestsHasMore
    );
    setProductRequestsPage(pageToLoad + 1);
  };

  // Load data when tab changes or user changes
  useEffect(() => {
    if (user?.user?.id) {
      if (activeTab === "Earned Points") {
        setEarnPoints([]);
        setEarnPointsPage(0);
        setEarnPointsHasMore(false);
        loadEarnPoints(0);
      } else if (activeTab === "Used Points") {
        setProductRequests([]);
        setProductRequestsPage(0);
        setProductRequestsHasMore(false);
        loadProductRequests(0);
      }
    }
  }, [activeTab, user?.user?.id]);

  const handleLoadMore = () => {
    loadEarnPoints(earnPointsPage);
  };

  const handleRequestLoadMore = () => {
    loadProductRequests(productRequestsPage);
  };

  return (
    <div>
      <div className="w-full sm:w-[300px] flex flex-col gap-3">
        <div className="flex flex-col gap-2">
          <span className="text-sm text-primaryText">
            Total
          </span>
          <span className="text-base font-bold text-primaryText">
            {user?.profiles?.ambassador?.totalEarnedPoints || 0} points
          </span>
        </div>
        <div className="flex gap justify-between">
          <span className="text-sm text-primaryText">
            Total Available Points
          </span>
          <span className="text-sm text-primaryText">{user?.profiles?.ambassador?.totalEarnedPoints || 0
            - user?.profiles?.ambassador?.totalSpentPoints || 0
          }</span>
        </div>
        <div className="flex gap justify-between">
          <span className="text-sm text-primaryText">Used points</span>
          <span className="text-sm text-primaryText">{user?.profiles?.ambassador?.totalSpentPoints || 0}</span>
        </div>
      </div>
      <div>
        <div className="flex gap-4 justify-start my-6">
          <button
            type="button"
            className={`px-4 py-2 text-xs font-bold transition-colors duration-300  ${activeTab === "Earned Points"
              ? "text-lightBlueColor border-b-2 border-lightBlueColor"
              : "text-mediumGrayText"
              }`}
            onClick={() => setActiveTab("Earned Points")}
          >
            Earned Points
          </button>
          <button
            type="button"
            className={`px-4 py-2 text-xs font-bold transition-colors duration-300  ${activeTab === "Used Points"
              ? "text-lightBlueColor border-b-2 border-lightBlueColor"
              : "text-mediumGrayText"
              }`}
            onClick={() => setActiveTab("Used Points")}
          >
            Used Points
          </button>
        </div>
        {activeTab === "Earned Points" && (
          <>
            <div className="flex flex-wrap items-center gap-6">
              {earnPoints.map((item, index) => (
                <div
                  key={index + 1}
                  className="border border-stokeLight rounded-[15px] p-6 flex flex-col items-center justify-center gap-2 text-center "
                >
                  <div className="flex flex-col gap-1 items-center justify-center">
                    <span className="text-sm text-goldenAmberText font-bold">
                      {item?.pointsEarned} pts
                    </span>
                    <span className="text-sm font-bold text-primaryText">
                      {item?.activity}
                    </span>
                    <span className="text-xs text-primaryText">
                      {item?.createdAt
                        ? new Intl.DateTimeFormat("en-US", {
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                        }).format(new Date(item?.createdAt))
                        : "-"}
                    </span>
                  </div>
                </div>
              ))}
            </div>
            {!isLoading && earnPoints.length >= 5 && earnPointsHasMore && (
              <div className="flex  justify-center mt-6">
                <button
                  onClick={handleLoadMore}
                  className="px-4 py-2 text-sm font-semibold text-white bg-lightBlueColor rounded"
                >
                  See More
                </button>
              </div>
            )}
            <div className="mt-4">
              <DataNotFound show={!isLoading && !earnPoints.length} />
            </div>
          </>
        )}

        {activeTab === "Used Points" && (
          <>
            <div className="flex flex-wrap items-center gap-6">
              {productRequests.map((item, index) => (
                <div
                  key={index + 1}
                  className="border border-stokeLight rounded-[15px] p-6 flex flex-col items-center justify-center gap-2 text-center "
                >
                  <div className="flex flex-col gap-1 items-center justify-center">
                    <span className="text-sm font-bold text-primaryText">
                      Notebook/Journal
                    </span>
                    <span className="text-xs text-primaryText">
                      {item?.createdAt
                        ? new Intl.DateTimeFormat("en-US", {
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                        }).format(new Date(item?.createdAt))
                        : "-"}
                    </span>
                    <span className="text-sm text-goldenAmberText font-bold">
                      10 pts
                    </span>
                  </div>
                </div>
              ))}
            </div>
            {!isLoading && productRequests.length >= 5 && productRequestsHasMore && (
              <div className="flex justify-center mt-6">
                <button
                  onClick={handleRequestLoadMore}
                  className="px-4 py-2 text-sm font-semibold text-white bg-lightBlueColor rounded"
                >
                  See More
                </button>
              </div>
            )}
            <div className="mt-4">
              <DataNotFound show={!isLoading && !productRequests.length} />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Wallet;
